export default __webpack_public_path__ + "cca1b81d2931995a360bce5cd7ef7b66.png";